<div class="card">
  <div class="card-header">
    <h1>Contador de documentos fiscales</h1>
  </div>

  <div class="card-body">
    <h5>Filtros</h5>

    <div class="row">
      <!-- <div class="col-sm-6 form-group">
        <label for="company" class="form-label">Empresa:</label>
        <div class="input-group">
            <small *ngIf="loadingCompanies" class="text-muted">
                <i class="fa fa-spinner fa-spin"></i>
                Cargando empresas...
            </small>
          <app-input-autocomplete
            (changeStatus)="selectCompany($event.filterElement)"
            (inputMethod)="searchCompany()"
            [allBorderRadius]="true"
            [filterElements]="companies"
            [placeholder]="'Busca una empresa'"
            [custom]="true"
            [inputs]="inputCompany">

            <ng-template #itemsTemplate let-filter>
              <div items>
                <h5 class="text-info" style="line-height: normal; margin-bottom: 0;">
                  {{ filter.companyName ? filter.companyName : filter.name }}
                </h5>
                <span class="text-muted" style="color: white !important;">
                  {{ filter.alphanumericId }} -
                  NIT: <b>{{ filter.companyNIT ? filter.companyNIT : filter.nit }}</b>
                </span>
              </div>
            </ng-template>

          </app-input-autocomplete>
        </div>
      </div> -->

      <div class="col-sm-auto form-group">
        <label for="startDate" class="form-label">Fecha Inicial</label>
        <input
          type="date"
          id="startDate"
          name="startDate"
          [(ngModel)]="startDate"
          class="form-control">
      </div>

      <div class="col-sm-auto form-group">
        <label for="endDate" class="form-label">Fecha Final</label>
        <input
          type="date"
          id="endDate"
          name="endDate"
          [(ngModel)]="endDate"
          class="form-control">
      </div>
      <div class="col-auto form-group">
          <div class="h-100 row align-items-end">
							<button class="btn btn-primary" (click)="filter()" [disabled]="loadingDocuments">
								<span class="spinner-border spinner-border-sm" aria-hidden="true" *ngIf="loadingDocuments"></span>
								<i class="fa fa-search" *ngIf="!loadingDocuments"></i>
							</button>
						</div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-sm-4">
        <div class="card text-center">
          <div class="card-body">
            <h6 class="text-muted">Documentos emitidos</h6>
            <h2 class="text-success">{{ totalIssued }}</h2>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card text-center">
          <div class="card-body">
            <h6 class="text-muted">Documentos anulados</h6>
            <h2 class="text-danger">{{ totalCancelled }}</h2>
          </div>
        </div>
      </div>

      <div class="col-sm-4">
        <div class="card text-center">
          <div class="card-body">
            <h6 class="text-muted">Total documentos</h6>
            <h2>{{ totalDocuments }}</h2>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-sm-12 form-group">
        <label for="filterWord" class="form-label">Búsqueda</label>
        <input
          type="text"
          id="filterWord"
          name="filterWord"
          placeholder="Buscar por empresa, NIT, serie o número"
          [(ngModel)]="filterWord"
          (input)="filterByWord()"
          class="form-control">
      </div>
    </div>

    <div *ngIf="loadingDocuments" class="text-center my-3">
        <i class="fa fa-spinner fa-spin fa-2x text-primary"></i>
        <p class="text-muted mt-2">Cargando documentos fiscales...</p>
    </div>
    <div class="table-responsive mt-2" style="margin: 0;" *ngIf="!loadingDocuments">
      <table class="table table-striped" style="margin: 0;">
        <thead>
          <tr class="tr-middle">
            <th (click)="sortBy('companyName')" style="cursor:pointer;">
            Empresa
            <i *ngIf="sortField === 'companyName'"
                [ngClass]="sortDirection === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down'">
            </i>
            </th>

            <th (click)="sortBy('invoicesTotal')" style="cursor:pointer;">
            Documentos Emitidos
            <i *ngIf="sortField === 'invoicesTotal'"
                [ngClass]="sortDirection === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down'">
            </i>
            </th>

            <th (click)="sortBy('cancelledTotal')" style="cursor:pointer;">
            Documentos Cancelados
            <i *ngIf="sortField === 'cancelledTotal'"
                [ngClass]="sortDirection === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down'">
            </i>
            </th>

            <th (click)="sortBy('total')" style="cursor:pointer;">
            Total
            <i *ngIf="sortField === 'total'"
                [ngClass]="sortDirection === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down'">
            </i>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr class="tr-middle" *ngFor="let item of pagination.filter">
            <td>{{ item.companyName }}</td>
            <td>{{ item.invoicesTotal }}</td>
            <td>{{ item.cancelledTotal }}</td>
            <td>{{ (item.invoicesTotal + item.cancelledTotal) }}</td>
          </tr>

          <tr *ngIf="pagination.filter.length === 0">
            <td colspan="6" class="text-center text-muted">
              No se encontraron documentos fiscales
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <app-pagination-custom [elements]="pagination"></app-pagination-custom>
  </div>
</div>